import React, {Fragment} from "react";
import {ActionType} from "../list/list/DataTable";
import {EventListRequest, EventType, Event } from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {createInitialState, ListView, ListViewProps, ListViewState} from "../ListView";
import {AnalyticsService} from "../../services/AnalyticsService";
import {Form, FormListener} from "../form/Form";
import {FormGroup} from "../form/FormGroup";
import {FormInput, StaticFormValue} from "../form/FormInput";
import {Validators} from "../form/Validators";
import {Submit} from "../form/Submit";
import {SelectInput} from "../form/SelectInput";
import {ColumnType} from "../list/list/ColumnType";


interface State extends ListViewState<EventListRequest> {
    listRequest? : EventListRequest;
    form? : EventListRequest;
    validationMap? : any;
    lookupExpanded?: boolean;
    blockedUsers: boolean;
    disableInitialSearch?: boolean;
}

function amountRenderer(prop : any, name : any, item : any) : any{
    return <div>{item.amount} {item.currency}</div>
}

export class PlayerAuditListView extends ListView<State, EventListRequest> implements FormListener<EventListRequest>{

    columns = [
        { property : "id", name : "ID"},
        { property : "type", name : "Event Type"},
        { property : "userId", name : "User"},
        { property : "timestamp", name : "Timestamp", type : ColumnType.DATE},
        { property : "remoteAddress", name : "Remote Address"},
        { property : "amountAccountRole", name : "Amount Account Role"},
        { property : "amount", name : "Amount", renderer: amountRenderer }
    ];

    actions = [
        { id : "userView", name : "View User", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/user/" + item.userId }
    ];

    date:any = new Date();
    initialState : EventListRequest = {
        limit: 20,
        orderBy: "id",
        types: [],
        startDate: (new Date(new Date().setDate(this.date.getDate() - 7)).toISOString().slice(0, 10) as any),
        endDate: (new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + 1).toISOString().slice(0, 10) as any),
        ascending: false,
        userId: undefined
    }

    service : AnalyticsService;

    constructor(props : ListViewProps){
        super(props, "/analytics-logs");
        this.service = getContainer().getAnalyticsService();

        let locProp = this.props.location;
        if (this.state.listRequest){
            let types:[] = [];
            let userId, startDate, endDate, disableInitialSearch = true;
            if(locProp.state && locProp.state.listRequest) {
                types = locProp.state.listRequest.types && locProp.state.listRequest.types;
                userId = locProp.state.listRequest.userId && locProp.state.listRequest.userId;
                startDate = locProp.state.listRequest.startDate && locProp.state.listRequest.startDate;
                endDate = locProp.state.listRequest.endDate && locProp.state.listRequest.endDate;
                disableInitialSearch = false
                this.initialState.types = types;
                this.initialState.userId = userId;
                this.initialState.startDate = startDate;
                this.initialState.endDate = endDate;
            }
            let lookupExpanded:boolean = false;
            if(locProp.state && locProp.state.lookupExpanded !== undefined) {
                lookupExpanded = locProp.state.lookupExpanded;
            }
            this.state = createInitialState( this.initialState, this.state = {lookupExpanded:lookupExpanded, disableInitialSearch: disableInitialSearch
                , searches: 0, ...this.state});
        }
    }
    onSubmit(): void {
        let listRequest : EventListRequest = Object.assign({},this.state.form);
        listRequest.offset = 0;
        listRequest["searches"] = (this.state.form.searches ? this.state.form.searches : 0) + 1;
        
        if(listRequest.types && listRequest.types.length )
        console.log("listRequest;: ", listRequest)
        this.updateListState(listRequest);
    };

    onSubmitError() :  void {
        console.log("submit error!")
    }

    formDidUpdate(formModel: EventListRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item : Event, action : string) : Promise<any> | undefined {
        if (action === "userView") {
            this.navigate("/user/" + item.userId);
        }
        return;
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.updateListState(listRequest);
        }
    }
    getTitle() {
        return "List Player Logs"
    }

    getSubTitle(): string {
        return "Please note the default date range is 7 days and that date ranges are required";
    }

    preset(preset: "day" | "week" | "month") {

        let filter: EventListRequest|undefined = this.state.listRequest;
        let today = new Date(new Date().setDate(new Date().getDate())).toISOString().slice(0,10);
        let yesterday = new Date(new Date().setDate(new Date().getDate()-1)).toISOString().slice(0,10);
        let sevenDaysAgo = new Date(new Date().setDate(new Date().getDate()-7)).toISOString().slice(0,10);
        let thirtyDaysAgo = new Date(new Date().setDate(new Date().getDate()-30)).toISOString().slice(0,10);

        switch(preset) {
            case "day":
                filter = {...this.state.form, startDate: yesterday as any, endDate: today as any};
                break;

            case "week":
                filter = {...this.state.form, startDate: sevenDaysAgo as any, endDate: today as any};
                break;

            case "month":
                filter = {...this.state.form, startDate: thirtyDaysAgo as any, endDate: today as any};
                break;
        }


        // this.updateListState({...filter});
        this.setState({form:filter})
    }

    getSearchByUserId() {
        return(
            <div className="row">
                <div className={"col-lg-6"}>
                    <div className="card-box">
                        <h4>Find By User Id</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="userId">
                                <FormInput model={"userId"} className={"form-control"} validators={[Validators.number()]}/>
                                <span className={"help-text"}>Finds logs by user id. Exact match only.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"}>Search</Submit>
                        </Form>
                    </div>

                </div>
            </div>
        )
    }

    getSearchByFilter() {

        return(
            <div className="card-box expandable-box" style={!this.state.lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !this.state.lookupExpanded ? this.setState({lookupExpanded:true}) : null}>
                {this.state.lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); this.setState({lookupExpanded : false});}}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); this.setState({lookupExpanded : true});}}><i className="mdi mdi-plus"></i></a>
                )}

                <h4 className="header-title mb-3" onClick={()=>this.setState({lookupExpanded : !this.state.lookupExpanded})}>Advanced Search</h4>
                {this.state.lookupExpanded && (
                    <div>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <div className="row">
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label>Timestamp</label>
                                        <h5>Presets</h5>
                                        <div>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("day")}>Day</span>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("week")}>Week</span>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("month")}>Month</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className={"form-group"}>
                                        <label htmlFor={"startDate"}>From:</label>
                                        <FormInput model={"startDate"} className={"form-control col-lg-6"} type={"date"} required={true} />
                                        <label htmlFor={"endDate"}>To:</label>
                                        <FormInput model={"endDate"} className={"form-control col-lg-6"} type={"date"} required={true} />
                                        <span className={"help-text"}>To but not included</span>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label>Event Types</label>
                                        <SelectInput className="form-control  col-lg-4" model="types" size={[...Object.keys(EventType)].length} multiple={true}
                                                     values={[...Object.keys(EventType)]}
                                                     optional={true}>
                                        </SelectInput>
                                        <span className={"help-text"}>Search for log based on their Type. CTRL select for multiple statuses.</span>
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label htmlFor={"remoteAddress"}>Remote Address</label>
                                        <FormInput model={"remoteAddress"} className={"form-control col-lg-6"} type={"text"}/>
                                        <StaticFormValue model={"searches"} type={"number"} />
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="form-group">
                                    <Submit className={"btn btn-primary"}>Search</Submit>
                                    <button onClick={() => this.clearFilter()} className={"btn btn-secondary"}>Clear</button>
                            </div>
                        </Form>
                    </div>
                )}
            </div>
        )
    }

    clearFilter() {
        this.setState({form: this.initialState})
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                {this.getSearchByUserId()}
                {this.getSearchByFilter()}
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}
                                 disableInitialSearch={this.state.disableInitialSearch}/>
            </Fragment>
        );
    }



}

export default withRouter(PlayerAuditListView)
